import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import styles from "./style.module.scss";

interface IAddRowButton {
    text: string;
    handleClick: () => void;
}

// Button of the type " + Text" as seen on Title form for adding a price per channel. This one stays the same once clicked (!= AddTextButton)
const AddRowButton = ({ text, handleClick }: IAddRowButton) => {
    return (
        <div onClick={handleClick} className={styles["add-row-button"]}>
            <AddOutlinedIcon sx={{ width: 18, height: 18 }} />
            {text}
        </div>
    );
};

export default AddRowButton;
